const bar = document.getElementById('hxa-bar');
const hero = document.querySelector('.hxa figure');
const stops = document.querySelectorAll('#hxa-offer, [data-hxa-cta="final"]');
const tick = () => {
  if (!bar) return;
  const past = hero && hero.getBoundingClientRect().bottom < 0;
  const block = [...stops].some(s => { const r = s.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; });
  const on = past && !block;
  bar.classList.toggle('is-on', on);
  bar.setAttribute('aria-hidden', on ? 'false' : 'true');
};
addEventListener('scroll', tick, { passive: true });
addEventListener('resize', tick);
tick();
